import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon: BoxIcon;
  color: string; // Tailwind color class like 'bg-blue-500'
}
export function StatCard({
  title,
  value,
  change,
  changeType,
  icon: Icon,
  color
}: StatCardProps) {
  // Extract color name for text coloring (e.g. 'bg-blue-500' -> 'text-blue-600')
  const colorName = color.replace('bg-', '').split('-')[0];
  return <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-520">
      <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-white/0 to-slate-50 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110`} data-id="element-521"></div>

      <div className="relative z-10" data-id="element-522">
        <div className="flex justify-between items-start mb-4" data-id="element-523">
          <div className={`p-3 rounded-xl ${color} bg-opacity-10 text-${colorName}-600`} data-id="element-524">
            <Icon className="h-6 w-6" data-id="element-525" />
          </div>
          {change && <span className={`
              inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
              ${changeType === 'positive' ? 'bg-green-100 text-green-800' : changeType === 'negative' ? 'bg-red-100 text-red-800' : 'bg-slate-100 text-slate-800'}
            `} data-id="element-526">
              {change}
            </span>}
        </div>

        <h3 className="text-slate-500 text-sm font-medium" data-id="element-527">{title}</h3>
        <p className="text-2xl font-bold text-seform-navy mt-1" data-id="element-528">{value}</p>
      </div>
    </div>;
}